import { AUTH_API_ROOT } from 'core/config/constants';
import { Api } from '../../libs/api';

export const apiAuthUi = new Api(`${AUTH_API_ROOT}/auth`);
